import { OdysseyRead } from 'api/schema'
import clsx from 'clsx'
import Box from 'components/Box/Box'
import SharedMissionItem from 'components/SharedMissionItem/SharedMissionItem'
import { useTranslation } from 'react-i18next'
import { IMissionInfo } from 'utils/interfaces'

import style from './MissionTable.module.css'

const MissionTable = ({
  missions,
  odysseys,
  highlightedMissionId,
  onMissionClick,
  onMissionsUpdated,
  onLaunchMission,
  onAddtoScenario,
}: {
  missions: IMissionInfo[]
  odysseys: OdysseyRead[]
  highlightedMissionId?: number
  onMissionClick?: (id: number) => void
  onMissionsUpdated: (deletedId?: number) => void
  onLaunchMission?: (mission: IMissionInfo) => void
  onAddtoScenario?: (id: number) => void
}) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={style.tableHeader}>
        <div></div>
        <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.id')}</div>
        <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.name')}</div>
        <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>{t('missions.tasks')}</div>
        <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>{t('missions.localization')}</div>
        <div></div>
      </div>
      {missions.length ? (
        <div className={style.table}>
          {missions.map(mission => (
            <SharedMissionItem
              key={mission.id}
              mission={mission}
              odysseys={odysseys}
              highlighted={highlightedMissionId === mission.id}
              onClick={() => onMissionClick?.(mission.id)}
              onMissionsDeleted={onMissionsUpdated}
              onLaunch={onLaunchMission}
              onAddtoScenario={onAddtoScenario}
            />
          ))}
        </div>
      ) : (
        <div className={style.emptyWrapper}>
          <div className={style.emptyTitle}>{t('missions.no_missions_title')}</div>
        </div>
      )}
    </>
  )
}

export default MissionTable
